<template>
  <div class="preview">
    <el-dialog test_id="withdrawalDialog" :top="subTip ? '7vh' : '15vh'"  :visible.sync="dialogVisible" width="100%" autofocus="fasle" :close="close" :before-close="close"
      :close-on-press-escape="closeModal" :close-on-click-modal="closeModal" :show-close="showClose">
      <div class="title" page_id="page_review">{{$t('common.preview_dialog.check_info')}}
      </div>
      <div class="tip">{{getTypeTip(type)}}</div>
      <div class="tip1"
           v-if="subTip"
           v-html="this.$t(`common.preview_dialog.${subTip}`)"></div>
      <div class="tip1"
           v-if="specialsubTip"
           v-html="specialsubTip"></div>
      <div class="preview-content">
        <div class="data" v-for="(item,key) in params" :key="key">
          <span class="data-left">{{getKey(key)}}</span>
          <span class="data-right" :class="{'red-color': ['serviceCharge', 'accountFee', 'actualAmount','financeFee','actualtransferAmount'].includes(key)}">
            {{['withdrawal_amount','outAmount','depositAmount', 'amount', 'serviceCharge', 'accountFee', 'actualAmount','financeFee','actualtransferAmount'].includes(key)? currency : ''}}
            <span>{{['withdrawal_amount','outAmount','depositAmount', 'amount', 'serviceCharge', 'accountFee', 'actualAmount','financeFee','actualtransferAmount'].includes(key)?Util.formatCurrency(item):item}}</span>
            <div v-if="key === 'actualAmount'">{{$t('withdrawal.actualAmountCredited')}}</div>
            <div v-if="key === 'accountFee' && currency !== 'USD'" class="account-fee-tip">
              <span style="margin-right: 5px">({{$t("exchange.referenceRate")}}</span>
              <span>1{{$t("common.usd")}}</span>
              <span>≈</span>
              <span>{{getRate(currency,'accountFee')}}{{currency==='HKD'?$t("common.hkd"):$t("common.cny")}})</span>
            </div>
            <div v-if="key === 'financeFee' && currency !== 'HKD'" class="account-fee-tip">
              <span style="margin-right: 5px">({{$t("exchange.referenceRate")}}</span>
              <span>{{getRate(currency,'financeFee')}}{{$t("common.hkd")}}</span>
              <span>≈</span>
              <span>1{{currency==='USD'?$t("common.usd"):$t("common.cny")}})</span>
            </div>
          </span>
        </div>
      </div>
      <slot></slot>
      <div class="preview-btn">
        <div class="sub-tipsub--btn">
          <el-button @click="submit" test_id="button_confirm" v-loading="loading" :disabled="loading" class="submit">{{$t('common.ok')}}</el-button>
        </div>
        <div class="sub-tipsub-btn">
          <el-button @click="close" test_id="button_edit" class="edit" :disabled="loading">{{$t('common.edit')}}</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: ['dialogVisible', 'params', 'type', 'handle', 'loading', 'closeModal', 'currency', 'subTip', 'sellRate', 'specialsubTip'],
  data () {
    return {
      showClose: false
    }
  },
  methods: {
    submit () {
      this.handle()
    },
    close (e) {
      this.$emit('update:dialogVisible', false)
      this.$emit('update:loading', false)
      this.$emit('closeHandle')
    },
    getTypeTip (key) {
      let items = this.$t('common.preview_dialog.tip')
      return items[key] ? items[key] : key
    },
    getKey (key) {
      let items = this.$t('common.preview_dialog')
      return items[key] ? items[key] : key
    },
    getRate (currency, key) {
      if (key === 'accountFee') {
        if (currency === 'HKD') {
        return this.fillZero(this.sellRate.usd && this.sellRate.usd.buy)
      } else if (currency === 'CNY') {
        return Math.round((this.sellRate.usd.buy / this.sellRate.cny.sell) * 100000) / 100000 || 0
      }
      } else if (key === 'financeFee') {
        if (currency === 'USD') {
          return this.fillZero(this.sellRate.usd.sell || 0)
        } else {
          return this.fillZero(this.sellRate.cny.sell || 0)
        }
      }
    },
    fillZero (val) {
      val = val + ''
      if (val.indexOf('.') < 0) {
        val = val + '.00000'
      } else {
        let decimalLen = 5 - val.split('.')[1].length
        console.log(decimalLen, 'decimalLen')
        for (let i = 0; i < decimalLen; i++) {
          val = val + '0'
        }
      }
      return val
    }
  }
}

</script>

<style lang="scss">
  .preview {
    .preview-content{
      // max-height: 250px;
      // overflow: hidden;
      // overflow-y: auto;
    }

    .el-dialog {
      max-width: 500px;
      min-height: 600px;
    }
    .el-dialog__header {
      display: none;
    }

    .el-dialog__body {
      padding: 30px 49px 30px;
    }

    .title {
      font-family: 'Muli-Bold';
      color: #24282d;
      font-size: 22px;
      border-bottom: 3px solid #e2e2e2;
      padding-bottom: 12px;
      margin-bottom: 20px;
    }

    .tip {
      font-size: 16px;
      color: #EE8515;
      font-family: 'Muli-Bold';
      padding-top: 0;
      padding-bottom: 10px;
    }

    .tip1 {
      padding-bottom: 10px;
      background: #FCF3F3;
      padding: 10px;
      color: #666666;
      border: 1px solid #ffcecd;
      border-radius: 4px;
      line-height: 20px;
    }

    .data {
      clear: none;
      border-bottom: 1px solid #e2e2e2;
      padding: 8px 0;
      overflow: hidden;
      .data-left {
        float: left;
        color: #7d7d7d;
        font-family: 'PingFangTC-Medium';
        font-size: 12px;
      }

      .data-right {
        float: right;
        font-size: 14px;
        color: #24282d;
        text-align: right;
        font-family: 'PingFangTC-Medium';
      }
      .red-color{
        color: #F13E3D
      }
    }

    .preview-btn {
      // padding-top: 30px;
    }

    .sub-tipsub--btn {
      text-align: center;
      width: 100%;
      padding-top: 10px;

      .el-button {
        margin-top: 10px;
        width: 100%;
        color: #192b57;
        font-weight: bold;
        height: 56px;
        border-color: #ffe080;
        background-color: #fecd33;
        max-width: 250px;
      }

      .el-button--primary:hover,
      .el-button--primary:focus {
        border-color: #fecd33;
        background-color: #fecd33;
        color: #192b57;
      }

      .el-button--primary span {
        font-family: Muli-Bold;
        font-size: 14px;
        color: #193060;
        letter-spacing: 0.17px;
      }
    }

    .sub-tipsub-btn {
      width: 100%;
      text-align: center;
      padding-top: 10px;

      .el-button {
        width: 250px;
        max-width: 248.9px;
        border: 1px solid #193060;
        margin-top: 10px;
        font-family: Muli-Bold;
        font-size: 14px;
        color: #193060;
        height: 56px !important;
      }

      .submit {
        border: 0;
        color: #000;
        background-color: #fec000;

        &:hover {
          height: 38px;
          border: 1px solid #e0e6f5;
          color: #000 !important;
          background-color: #fff !important;
        }
      }
    }
    .account-fee-tip{
      color: #7d7d7d;
      font-size: 12px;
    }
  }

</style>
